<div [class]="computedClasses">
  <div [class]="bodyClasses">
    <ng-content></ng-content>
  </div>
</div>

